import {Switch} from "@/components/ui/switch";
import {cn} from "@/lib/utils";

type Props = {
  title: string;
  description?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
};

/** Binary on/off control — iOS-style Switch in admin brand colors. */
export function AdminToggleField({
  title,
  description,
  checked,
  onCheckedChange,
  disabled,
  className
}: Props) {
  return (
    <div className={cn("admin-toggle-field", className)}>
      <div className="admin-toggle-field__copy min-w-0">
        <p className="admin-toggle-field__title">{title}</p>
        {description ? <p className="admin-toggle-field__desc">{description}</p> : null}
      </div>
      <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className="admin-ios-switch"
        aria-label={title}
      />
    </div>
  );
}
